import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "rightSlot", "shouldRenderClearFilters"],
  _excluded2 = ["children", "rightSlot", "shouldRenderClearFilters"];
import { Box } from 'foundations-components/transitional/components/Box';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { FILTER_TYPES } from '../../../constants/TopFilterConstants';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import useSearchParams from '../../../hooks/useSearchParams';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const nonClearableFilters = [FILTER_TYPES.SEARCH, FILTER_TYPES.CATEGORY, FILTER_TYPES.TOOLS];
const useClearFilters = () => {
  const allFilters = Object.values(FILTER_TYPES);
  const [searchParams, setSearchParams] = useSearchParams();
  const filters = Object.keys(searchParams).filter(key => allFilters.includes(key) && !nonClearableFilters.includes(key));
  const handleClearFilters = () => {
    const clearedFilters = filters.reduce((acc, filter) => {
      acc[filter] = undefined;
      return acc;
    }, {});
    setSearchParams(clearedFilters);
  };
  return {
    filters,
    handleClearFilters
  };
};
export const FiltersBar = _ref => {
  let {
      children,
      rightSlot,
      shouldRenderClearFilters = true
    } = _ref,
    flexProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    filters,
    handleClearFilters
  } = useClearFilters();
  return /*#__PURE__*/_jsxs(Flex, Object.assign({
    alignItems: "center",
    gap: "400"
  }, flexProps, {
    children: [/*#__PURE__*/_jsx(Box, {
      grow: 1,
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        flexWrap: "wrap",
        gap: "200",
        children: [children, !!filters.length && shouldRenderClearFilters && /*#__PURE__*/_jsx(Button, {
          onClick: handleClearFilters,
          use: "transparent",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyComponents.filters.clearFilters"
          })
        })]
      })
    }), rightSlot && /*#__PURE__*/_jsx(Box, {
      children: rightSlot
    })]
  }));
};
export const FiltersCard = _ref2 => {
  let {
      children,
      rightSlot,
      shouldRenderClearFilters = true
    } = _ref2,
    options = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(CardWrapper, Object.assign({
    marginBlockEnd: "600",
    padding: "400"
  }, options, {
    children: /*#__PURE__*/_jsx(FiltersBar, {
      rightSlot: rightSlot,
      shouldRenderClearFilters: shouldRenderClearFilters,
      children: children
    })
  }));
};